module.exports = __webpack_public_path__ + "static/media/logo.28c88535.png";